<mat-card class="flex flex-col p-4">
  <mat-card-title>Status: Approved <mat-icon class="translate-y-1">check</mat-icon></mat-card-title>
  <span class="ml-2 mt-2"><strong>Approved by:</strong> {{quoteInfo.approverName}}</span>
  <span class="ml-2"><strong>Approver's email:</strong> {{quoteInfo.approverEmail}}</span>
  <span class="ml-2"><strong>{{quoteInfo.isEstimate === 'estimate' ? 'Estimated install date: ' : 'Requested Install Date: '}}</strong>{{ quoteInfo.installDate ? (quoteInfo.installDate | date) : 'Unknown' }}</span>
  <span class="ml-2"><strong>PO number:</strong> {{quoteInfo.po ? quoteInfo.po : 'No PO number was provided' }} </span>
  <span class="ml-2"><strong>Approval Date:</strong> {{quoteInfo.approvedTs | date}}</span>
</mat-card>
